var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAhrOutlineSix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4514_263)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 27.625H27.625",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4514_263",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H32V32H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4514_263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5053 19.6523C32.9341 14.4711 31.5134 7.49047 26.3322 4.06172C21.1509 0.632969 14.1709 2.05297 10.7422 7.23484L29.5053 19.6523Z",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9306 3.53468C28.3594 4.39843 27.1962 4.63468 26.3325 4.06343C25.4687 3.49218 25.2325 2.32843 25.8038 1.46531C26.375 0.601558 27.5387 0.364683 28.4019 0.936558C29.2656 1.50781 29.5025 2.67093 28.9306 3.53468Z",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4453 20.3994C10.4453 19.0306 11.3946 17.875 12.7716 17.875C14.5391 17.875 15.0609 19.9375 15.0609 19.9375C15.0609 19.9375 15.6552 17.875 17.4228 17.875C18.7997 17.875 19.7484 19.0306 19.7484 20.3994C19.7484 22.2787 17.8809 22.9306 15.0609 25.375C12.3022 22.9844 10.4453 22.2931 10.4453 20.3994Z",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0625 32C14.7176 32 14.4375 31.7199 14.4375 31.375C14.4375 31.0301 14.7176 30.75 15.0625 30.75C15.4074 30.75 15.6875 31.0301 15.6875 31.375C15.6875 31.7199 15.4074 32 15.0625 32Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5 27.625H27.625C26.5894 27.625 25.75 28.4644 25.75 29.5C25.75 30.5356 24.9106 31.375 23.875 31.375H17.875",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 31.375H6.25C5.21438 31.375 4.375 30.5356 4.375 29.5C4.375 28.4644 3.53562 27.625 2.5 27.625H0.625",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4514_263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhrOutlineSix);
export default __webpack_public_path__ + "static/media/ahr-outline-six.a9a71660a6f414493c05c07201d7bcdb.svg";
export { ForwardRef as ReactComponent };